import * as React from 'react';
import { IconProps } from '../types';

const IcPrint = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5.373 5.25H19.627a2.63 2.63 0 0 1 2.623 2.623v7.504A2.63 2.63 0 0 1 19.627 18H18.5v-1.5h1.124a1.131 1.131 0 0 0 1.126-1.126V7.876a1.13 1.13 0 0 0-1.126-1.126H5.376A1.13 1.13 0 0 0 4.25 7.876v7.498A1.13 1.13 0 0 0 5.376 16.5H6.5V18H5.373a2.63 2.63 0 0 1-2.623-2.623V7.873A2.63 2.63 0 0 1 5.373 5.25Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M7.64 12a.39.39 0 0 0-.39.39v7.47c0 .215.175.39.39.39h9.72a.39.39 0 0 0 .39-.39v-7.47a.39.39 0 0 0-.39-.39H7.64Zm-1.89.39a1.89 1.89 0 0 1 1.89-1.89h9.72a1.89 1.89 0 0 1 1.89 1.89v7.47a1.89 1.89 0 0 1-1.89 1.89H7.64a1.89 1.89 0 0 1-1.89-1.89v-7.47ZM8.373 2.25H16.627a2.63 2.63 0 0 1 2.623 2.623V6h-1.5V4.876a1.131 1.131 0 0 0-1.126-1.126H8.376A1.13 1.13 0 0 0 7.25 4.876V6h-1.5V4.873A2.63 2.63 0 0 1 8.373 2.25Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M18.875 9.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
    />
  </svg>
);

export default IcPrint;